import html2canvas from 'html2canvas';

/**
 * Génère un PNG à partir d'un noeud DOM déjà rendu (la carte). Centralisé pour
 * que le rendu téléchargé soit toujours produit avec les mêmes réglages,
 * peu importe l'écran d'où le téléchargement est déclenché.
 */
async function captureNode(node) {
  const canvas = await html2canvas(node, { scale: 3, useCORS: true, backgroundColor: '#ffffff', logging: false });
  return canvas;
}

function triggerDownload(dataUrl, filename) {
  const link = document.createElement('a');
  link.download = filename;
  link.href = dataUrl;
  link.click();
}

/**
 * Télécharge le recto seul en PNG.
 * `frontNode` : élément DOM du recto déjà rendu (via CardRenderer).
 */
export async function downloadCardFront(frontNode, memberCode) {
  const canvas = await captureNode(frontNode);
  triggerDownload(canvas.toDataURL('image/png'), `carte-${memberCode || 'membre'}.png`);
}

/**
 * Télécharge recto + verso empilés verticalement dans une seule image PNG.
 * `frontNode`/`backNode` : éléments DOM déjà rendus.
 */
export async function downloadCardBothSides(frontNode, backNode, memberCode) {
  const [frontCanvas, backCanvas] = await Promise.all([captureNode(frontNode), captureNode(backNode)]);
  const gap = 24;
  const width = Math.max(frontCanvas.width, backCanvas.width);
  const height = frontCanvas.height + backCanvas.height + gap;

  const combined = document.createElement('canvas');
  combined.width = width;
  combined.height = height;
  const ctx = combined.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(frontCanvas, (width - frontCanvas.width) / 2, 0);
  ctx.drawImage(backCanvas, (width - backCanvas.width) / 2, frontCanvas.height + gap);

  triggerDownload(combined.toDataURL('image/png'), `carte-${memberCode || 'membre'}-recto-verso.png`);
}
